import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useMemo } from 'react';
import type { Me } from 'eds-common/api/v2';

export function useLaunchDarklyIdentify(user?: Me | null) {
  const ldClient = useLDClient();

  const identity = useMemo(
    () =>
      user
        ? {
            key: user.userId,
            custom: {
              orgId: user.currentOrg.orgId,
              role: user.currentRole,
            },
          }
        : null,
    [user]
  );

  useEffect(() => {
    if (identity) {
      ldClient
        ?.identify(identity)
        .catch((err) =>
          console.error('Could not identify user to LaunchDarkly', err)
        );
    }
  }, [identity, ldClient]);
}
